import * as CookieConsent from "vanilla-cookieconsent";

const CAT_NECESSARY = "necessary";
const CAT_ANALYTICS = "analytics";
const CAT_MARKETING = "marketing";

const SERVICE_AD_STORAGE = "ad_storage";
const SERVICE_AD_USER_DATA = "ad_user_data";
const SERVICE_AD_PERSONALIZATION = "ad_personalization";
const SERVICE_ANALYTICS_STORAGE = "analytics_storage";
const SERVICE_FUNCTIONALITY_STORAGE = "functionality_storage";
const SERVICE_PERSONALIZATION_STORAGE = "personalization_storage";
const SERVICE_SECURITY_STORAGE = "security_storage";

window.dataLayer = window.dataLayer || [];
function gtag() {
  window.dataLayer.push(arguments);
}

// Consent default is set server-side in GoogleTagManager.cshtml before GTM loads.
// Here we only do consent "update" and consent_ready when the user has chosen (or cookie is restored).

/**
 * GTM Custom Event: "consent known, safe to fire pageview tags". Fired from onConsent
 * (once on first accept, once per load on return visits when cookie is restored).
 * In GTM, create a Custom Event trigger "consent_ready" for GA4/Facebook/Google Ads pageviews.
 */
const GTM_EVENT_CONSENT_READY = "consent_ready";

function updateGtagConsent() {
  gtag("consent", "update", {
    [SERVICE_ANALYTICS_STORAGE]: CookieConsent.acceptedCategory(CAT_ANALYTICS)
      ? "granted"
      : "denied",
    [SERVICE_AD_STORAGE]: CookieConsent.acceptedCategory(CAT_MARKETING)
      ? "granted"
      : "denied",
    [SERVICE_AD_USER_DATA]: CookieConsent.acceptedCategory(CAT_MARKETING)
      ? "granted"
      : "denied",
    [SERVICE_AD_PERSONALIZATION]: CookieConsent.acceptedCategory(CAT_MARKETING)
      ? "granted"
      : "denied",
    [SERVICE_FUNCTIONALITY_STORAGE]: CookieConsent.acceptedCategory(
      CAT_NECESSARY
    )
      ? "granted"
      : "denied",
    [SERVICE_PERSONALIZATION_STORAGE]: CookieConsent.acceptedCategory(
      CAT_MARKETING
    )
      ? "granted"
      : "denied",
    [SERVICE_SECURITY_STORAGE]: CookieConsent.acceptedCategory(CAT_NECESSARY)
      ? "granted"
      : "denied"
  });
}

function inIframe() {
  try {
    return window.self !== window.top;
  } catch (e) {
    return true;
  }
}

window.addEventListener("load", function () {
  if (inIframe()) {
    return;
  }

  if (!window.cookieConsentConfig) {
    return;
  }

  CookieConsent.run({
    cookie: window.cookieConsentConfig.cookie,
    categories: {
      [CAT_NECESSARY]: {
        enabled: true, // this category is enabled by default
        readOnly: true // this category cannot be disabled
      },
      [CAT_MARKETING]: {},
      [CAT_ANALYTICS]: {
        autoClear: {
          cookies: [
            {
              name: /^_ga/ // regex: match all cookies starting with '_ga'
            },
            {
              name: "_gid" // string: exact cookie name
            }
          ]
        }
      }
    },
    language: {
      default: window.cookieConsentConfig.currentLang,
      translations: window.cookieConsentConfig.language
    },
    guiOptions: {
      consentModal: {
        layout: "box inline",
        position: "bottom right",
        equalWeightButtons: false
      },
      preferencesModal: {
        layout: "box",
        equalWeightButtons: false
      }
    },
    onFirstConsent: () => {
      updateGtagConsent();
    },
    onConsent: ({ cookie }) => {
      updateGtagConsent();
      // GTM: signal that consent is known so pageview tags (GA4, Facebook, Google Ads) can fire.
      window.dataLayer = window.dataLayer || [];
      window.dataLayer.push({ event: GTM_EVENT_CONSENT_READY });
      // Matomo: notify that consent was given/updated (lifecycle event).
      if (window._mtm) {
        window._mtm.push({
          event: "cookieConsentAccepted",
          cookieConsent: cookie.categories
        });
      }
    },
    onChange: () => {
      updateGtagConsent();
    }
  });
});
